// services/fontteService/reminders.ts - services/fontteService.ts split (sub-module reminders)

import { getApiUrl } from '../apiConfig.js';
import { withRetry } from '../../utils/retryLogic';

import type {FontteResponse} from './types.js';
import type {PaymentReminderParams} from './types.js';
import { VPS_API_KEY } from './config.js';
import { VPS_API_URL } from './config.js';


export async function sendPaymentReminder(params: PaymentReminderParams): Promise<FontteResponse> {
  const VPS_API_URL = getApiUrl();
  const VPS_API_KEY = import.meta.env.VITE_VPS_API_KEY || '';

  if (!VPS_API_URL) {
    return { status: false, message: 'VPS_API_URL not configured', errorCode: 'CONFIG_ERROR' };
  }

  try {
    const response = await withRetry(() => fetch(`${VPS_API_URL}/api/whatsapp/send-payment-reminder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': VPS_API_KEY,
      },
      body: JSON.stringify(params),
      signal: AbortSignal.timeout(15000),
    }), {
      maxRetries: 2,
      initialDelayMs: 1000,
      backoffMultiplier: 2,
      shouldRetry: (err) => {
        if (err instanceof TypeError) return true;
        return false;
      },
    });

    const text = await response.text();
    let data;
    try { data = JSON.parse(text); } catch { data = null; }

    if (!response.ok || (data && !data.success)) {
      return {
        status: false,
        message: data?.error || text || 'Gagal mengirim pengingat pembayaran',
        errorCode: 'REMINDER_ERROR',
        details: { status: response.status, response: data || text }
      };
    }

    return { status: true, message: 'Pengingat pembayaran terkirim', data: data?.data };
  } catch (error: any) {
    return {
      status: false,
      message: error.message || 'Payment reminder API connection failed',
      errorCode: 'REMINDER_NETWORK_ERROR'
    };
  }
}
